module.exports = __webpack_public_path__ + "static/media/mission.9a6e3dfe.svg";